import { render, staticRenderFns } from "./ArchiveSectionModal.vue?vue&type=template&id=9c1e7916&scoped=true&"
import script from "./ArchiveSectionModal.vue?vue&type=script&lang=js&"
export * from "./ArchiveSectionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c1e7916",
  null
  
)

export default component.exports